import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// === ИСПРАВЛЕННЫЕ ПУТИ ИМПОРТА ===
import API from '../api/axiosConfig';
import MathText from '../components/MathText';

function AssignedTestPage() {
  const { eventId } = useParams(); 
  const navigate = useNavigate();
  
  const [testInfo, setTestInfo] = useState(null); 
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [displayQuestion, setDisplayQuestion] = useState(null);
  
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  
  const [isSending, setIsSending] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const [userAnswers, setUserAnswers] = useState([]);

  useEffect(() => {
    setLoading(true);
    API.get(`/api/student/events/${eventId}/take/`)
      .then(res => {
        setTestInfo({ title: res.data.title, description: res.data.description });
        setQuestions(res.data.questions);
        if (res.data.questions.length > 0) {
          setDisplayQuestion(res.data.questions[0]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Ошибка API:", err);
        setErrorMsg(err.response?.data?.error || "Произошла ошибка при загрузке теста.");
        setLoading(false);
      });
  }, [eventId]);

  useEffect(() => {
    if (window.MathJax && displayQuestion && !loading) {
      window.MathJax.typesetPromise()
        .then(() => setIsTransitioning(false))
        .catch(() => setIsTransitioning(false));
    } else {
        setIsTransitioning(false);
    }
  }, [displayQuestion, loading]);

  const handleAnswerClick = async (ans) => {
    if (isTransitioning) return;

    const currentAnswerData = {
      question_id: displayQuestion.id,
      answer_id: ans.id,
      is_correct: ans.is_correct
    };
    
    const newUserAnswers = [...userAnswers, currentAnswerData];
    setUserAnswers(newUserAnswers);

    const newScore = ans.is_correct ? score + 1 : score;
    const nextIndex = currentQuestionIndex + 1;

    if (nextIndex < questions.length) {
      setIsTransitioning(true);
      setTimeout(() => {
        setScore(newScore);
        setCurrentQuestionIndex(nextIndex);
        setDisplayQuestion(questions[nextIndex]);
      }, 300);

    } else {
      setScore(newScore);
      setIsSending(true);
      
      try {
        await API.post('/api/results/', {
          subject: displayQuestion.subject || 1, 
          class_level: displayQuestion.class_level || 5, 
          score: newScore,
          total_questions: questions.length,
          answers_list: newUserAnswers,
          event_id: eventId 
        });
        setShowResult(true);
      } catch (err) {
        console.error("Ошибка отправки:", err);
        setShowResult(true); 
      } finally {
        setIsSending(false);
      }
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-screen"><div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div></div>;
  
  if (errorMsg) return (
      <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50 text-center">
          <span className="text-5xl mb-4">⚠️</span>
          <h2 className="text-xl font-bold text-gray-800 mb-2">{errorMsg}</h2>
          <button onClick={() => navigate('/student-dashboard')} className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-xl font-bold">Вернуться назад</button>
      </div>
  );

  if (!displayQuestion) return <div className="flex flex-col items-center justify-center min-h-screen text-gray-500 font-bold">В этом тесте нет вопросов.</div>;
  
  if (showResult) return (
     <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white p-10 rounded-3xl shadow-xl text-center max-w-md w-full border border-gray-100">
           <h2 className="text-xl font-black text-gray-800 mb-2">Тест завершен!</h2>
           <p className="text-xs text-gray-500 font-bold uppercase tracking-widest mb-6">{testInfo?.title}</p>
           <div className="text-6xl font-black text-blue-600 mb-8">{score} <span className="text-3xl text-gray-400">/ {questions.length}</span></div>
           <button onClick={() => navigate('/student-dashboard')} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-xl font-bold transition-colors">Вернуться в кабинет</button>
        </div>
     </div>
  );

  const progress = ((currentQuestionIndex + 1) / questions.length) * 100;

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-3xl mx-auto">
        
        <div className="mb-8">
            <h1 className="text-lg font-black text-gray-800 mb-1">{testInfo?.title}</h1>
            <div className="flex justify-between mb-3 items-end">
                <span className="text-xs font-black text-blue-600 uppercase tracking-widest">Вопрос {currentQuestionIndex + 1} из {questions.length}</span>
                <span className="text-blue-600 font-black">{Math.round(progress)}%</span>
            </div>
            <div className="w-full bg-gray-200 h-3 rounded-full overflow-hidden">
                <div className="bg-blue-500 h-full transition-all duration-500" style={{ width: `${progress}%` }}></div>
            </div>
        </div>

        <div className={`bg-white rounded-[2rem] shadow-xl p-6 md:p-10 border border-gray-100 transition-opacity duration-300 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}>
          
          <div className="text-lg md:text-xl font-bold text-gray-800 mb-8">
              <MathText text={displayQuestion.text} />
          </div>

          {displayQuestion.image && (
              <img src={displayQuestion.image} alt="Вопрос" className="max-h-64 object-contain rounded-xl mb-8 border border-gray-200 bg-gray-50 w-full" />
          )}

          <div className="space-y-3">
            {displayQuestion.answers && displayQuestion.answers.map((ans, i) => (
              <button
                key={i}
                disabled={isSending || isTransitioning}
                onClick={() => handleAnswerClick(ans)}
                className="w-full text-left p-4 border-2 border-gray-100 rounded-2xl hover:border-blue-500 hover:bg-blue-50 transition-all flex items-center group"
              >
                <span className="w-10 h-10 shrink-0 bg-gray-100 rounded-xl flex items-center justify-center mr-4 text-sm font-black text-gray-500 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                  {['А', 'Б', 'В', 'Г', 'Д'][i] || String.fromCharCode(65 + i)}
                </span>
                <span className="text-base font-semibold text-gray-700 group-hover:text-blue-900">
                    <MathText text={ans.text} />
                </span>
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default AssignedTestPage;